import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { TablePageShimmer } from './shimmers/TablePageShimmer';
import { DetailPageShimmer } from './shimmers/DetailPageShimmer';
import { FormPageShimmer } from './shimmers/FormPageShimmer';
import { DashboardShimmer } from './shimmers/DashboardShimmer';
import { PaymentRequestsShimmer } from './shimmers/PaymentRequestsShimmer';
interface PageTransitionWrapperProps {
  children: React.ReactNode;
}
type PageType = 'table' | 'detail' | 'form' | 'dashboard' | 'payment-requests';
const getPageType = (pathname: string): PageType => {
  // Dashboard pages
  if (pathname === '/' || pathname === '/overview') return 'dashboard';
  // Payment requests
  if (pathname === '/payment-requests') return 'payment-requests';
  // Detail pages
  if (pathname.includes('-detail/') || pathname.includes('/customer-detail/') || pathname.includes('/invoice-detail/') || pathname.includes('/sale-detail/') || pathname.includes('/settlement-detail/') || pathname.includes('/dispute-detail/') || pathname.includes('/refund-detail/') || pathname.includes('/supplier-detail/') || pathname.includes('/bill-detail/') || pathname.includes('/bulk-payment-detail/')) {
    return 'detail';
  }
  // Form pages
  if (pathname.includes('-form') || pathname.includes('/add-') || pathname.includes('/edit-') || pathname.includes('-approval/') || pathname.includes('-financing/')) {
    return 'form';
  }
  // Default to table for list pages
  return 'table';
};
export function PageTransitionWrapper({
  children
}: PageTransitionWrapperProps) {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [pageType, setPageType] = useState<PageType>('table');
  useEffect(() => {
    // Show shimmer on route change
    setIsLoading(true);
    setPageType(getPageType(location.pathname));
    // Hide shimmer after a brief delay to simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  const renderShimmer = () => {
    switch (pageType) {
      case 'dashboard':
        return <DashboardShimmer data-id="element-1463" />;
      case 'payment-requests':
        return <PaymentRequestsShimmer data-id="element-1464" />;
      case 'detail':
        return <DetailPageShimmer data-id="element-1465" />;
      case 'form':
        return <FormPageShimmer data-id="element-1466" />;
      case 'table':
      default:
        return <TablePageShimmer data-id="element-1467" />;
    }
  };
  return <AnimatePresence mode="wait" data-id="element-1468">
      {isLoading ? <motion.div key="shimmer" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.15
    }} data-id="element-1469">
          {renderShimmer()}
        </motion.div> : <motion.div key={location.pathname} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.15
    }} data-id="element-1470">
          {children}
        </motion.div>}
    </AnimatePresence>;
}